import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useRef, useEffect } from 'react';
import { CarouselContainer, NavButton, Carousel as Carousel$2, ScrollIndicator, Part } from './Carousel.style.js';
import debounce from '../../utils/debounce.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';
import GridBleed from '../Grid/GridBleed.js';
import Icon from '../Icon/Icon.js';
import { ICON_UI_CHEVRON_LEFT } from '../../icons/ICON_UI_CHEVRON_LEFT.js';

function clamp(number, min, max) {
  return Math.max(min, Math.min(number, max));
}
function isElementVisible(el, holder) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
    left = _el$getBoundingClient.left,
    right = _el$getBoundingClient.right,
    width = _el$getBoundingClient.width;
  var holderRect = holder.getBoundingClientRect();
  return left + width / 2 > holderRect.left && right - width / 2 < holderRect.right;
}
function getPageSize(itemSize, itemSizeTablet, itemSizeMobile) {
  if (typeof window !== 'undefined' && window.innerWidth < 768) {
    return Math.floor(4 / itemSizeMobile);
  }
  if (typeof window !== 'undefined' && window.innerWidth < 1024) {
    return Math.floor(12 / itemSizeTablet);
  }
  return Math.floor(12 / itemSize);
}
var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    _ref$itemSize = _ref.itemSize,
    itemSize = _ref$itemSize === void 0 ? 4 : _ref$itemSize,
    _ref$itemSizeTablet = _ref.itemSizeTablet,
    itemSizeTablet = _ref$itemSizeTablet === void 0 ? 6 : _ref$itemSizeTablet,
    _ref$itemSizeMobile = _ref.itemSizeMobile,
    itemSizeMobile = _ref$itemSizeMobile === void 0 ? 4 : _ref$itemSizeMobile,
    _ref$tightNavPosition = _ref.tightNavPosition,
    tightNavPosition = _ref$tightNavPosition === void 0 ? false : _ref$tightNavPosition;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPosition = _useState2[0],
    setScrollPosition = _useState2[1];
  var wrapperRef = useRef(null);
  var pageSize = getPageSize(itemSize, itemSizeTablet, itemSizeMobile);
  var isGlobe = useIsGlobetrotter();
  var handleScroll = debounce(function () {
    if (!wrapperRef.current) {
      return;
    }
    var visibleIndex = 0;
    _toConsumableArray(wrapperRef.current.children).forEach(function (el, index) {
      if (isElementVisible(el, wrapperRef.current)) {
        visibleIndex = index;
      }
    });
    setScrollPosition(visibleIndex + 1 - pageSize);
  }, 25, {
    leading: true,
    trailing: true
  });
  useEffect(function () {
    var element = wrapperRef.current;
    if (!element) {
      return undefined;
    }
    element.addEventListener('touchmove', handleScroll);
    element.addEventListener('scroll', handleScroll);
    return function () {
      element.removeEventListener('scroll', handleScroll);
      element.removeEventListener('touchmove', handleScroll);
    };
  });
  if (!children) {
    return null;
  }
  function nav() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var newIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var newScrollPosition = newIndex !== null ? newIndex : clamp(scrollPosition + pageSize * direction, 0, children.length - pageSize);
    var el = wrapperRef.current.children[newScrollPosition];
    if (!el) {
      return;
    }
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
  }
  var activePrevButton = scrollPosition > 0;
  var activeNextButton = scrollPosition < children.length - pageSize;
  return /*#__PURE__*/jsx(GridBleed, {
    variant: "full-mobile",
    children: /*#__PURE__*/jsxs(CarouselContainer, {
      children: [children.length > pageSize && /*#__PURE__*/jsx(NavButton, {
        // @ts-ignore
        $disabled: !activePrevButton,
        $tightNavPosition: tightNavPosition,
        "aria-hidden": "true",
        onClick: function onClick() {
          return activePrevButton && nav(-1);
        },
        children: /*#__PURE__*/jsx(Icon, {
          path: ICON_UI_CHEVRON_LEFT,
          size: "xs"
        })
      }), /*#__PURE__*/jsx(Carousel$2, {
        className: "uikit-carousel-items",
        ref: wrapperRef
        // @ts-ignore
        ,
        $itemSize: itemSize,
        $itemSizeTablet: itemSizeTablet,
        $itemSizeMobile: itemSizeMobile,
        children: children
      }), children.length > pageSize && isGlobe && /*#__PURE__*/jsx(ScrollIndicator, {
        children: _toConsumableArray(Array(children.length).keys()).map(function (index) {
          return /*#__PURE__*/jsx(Part, {
            "aria-hidden": "true",
            tabIndex: -1,
            onClick: function onClick() {
              return nav(1, index);
            },
            // @ts-ignore
            $active: index >= scrollPosition && index < scrollPosition + pageSize
          }, index);
        })
      }), children.length > pageSize && /*#__PURE__*/jsx(NavButton, {
        // @ts-ignore
        $disabled: !activeNextButton,
        $tightNavPosition: tightNavPosition,
        "aria-hidden": "true",
        onClick: function onClick() {
          return activeNextButton && nav();
        },
        $right: true,
        children: /*#__PURE__*/jsx(Icon, {
          path: ICON_UI_CHEVRON_LEFT,
          size: "xs"
        })
      })]
    })
  });
};
var Carousel$1 = Carousel;

export { Carousel$1 as default };
//# sourceMappingURL=Carousel.js.map
